import { ChangeDetectionStrategy, Component, InputSignal, OutputEmitterRef, input, output } from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';

import { ActionButtonComponent } from '../action-button/action-button.component';

@Component({
  selector: 'mp-actions-slide-toggle-button',
  templateUrl: './actions-slide-toggle-button.component.html',
  styleUrl: './actions-slide-toggle-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatSlideToggle, ActionButtonComponent],
})
export class ActionsSlideToggleButtonComponent {
  readonly icon: InputSignal<string | undefined> = input<string>();
  readonly label: InputSignal<string> = input<string>('');

  readonly checked: InputSignal<boolean> = input<boolean>(false);

  readonly disabled: InputSignal<boolean> = input<boolean>(false);

  readonly buttonClick: OutputEmitterRef<void> = output<void>();

  emitClick(): void {
    this.buttonClick.emit();
  }
}
